import { onCleanup, onMount } from 'solid-js';
import { markUpdateAvailable } from '../utils/appUpdate';

const CHECK_INTERVAL_MS = 10 * 60 * 1000; // alle 10 Minuten

/**
 * Vergleicht die Build-Version mit /version.json. Weicht sie ab, wird KEIN Reload
 * mehr erzwungen, sondern das Update-Banner eingeblendet (appUpdate.ts). Dient als
 * Fallback für Browser ohne Service Worker; mit SW kommt die Meldung meist über
 * onNeedRefresh in main.tsx.
 */
export function useVersionCheck() {
  if (import.meta.env.DEV) return;

  const currentVersion = __BUILD_VERSION__;
  let isChecking = false;
  let reported = false;

  async function checkVersion() {
    if (isChecking || reported) return;
    isChecking = true;

    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;

      const data = await res.json();
      const serverVersion: string = data?.version;
      if (!serverVersion || serverVersion === currentVersion) return;

      reported = true;
      markUpdateAvailable('version');
    } catch {
      // Netzwerkfehler ignorieren
    } finally {
      isChecking = false;
    }
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      checkVersion();
    }
  }

  onMount(() => {
    // Ersten Check erst nach 15 Sekunden – SW braucht Zeit zum Aktivieren
    const initial = setTimeout(checkVersion, 15_000);
    const interval = setInterval(checkVersion, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);

    onCleanup(() => {
      clearTimeout(initial);
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    });
  });
}
